import actions from './actions'
import copyScene from './metaData/copyScene'
export default {
  state: copyScene,
  actions
}
